<template>
    <div>
        <Head style="backgroundColor: #fff"></Head>
        <navigationbar cid="0"></navigationbar>
         <div class='bg-top'></div>
        <div class=" flex flex-direction align-center content">
             <!-- 顶部背景图 -->
            <!-- <div class='bg-top'></div> -->
            
            <div class='wrap width flex'>

                <!-- 文章正文 -->
                <div class='l flex-sub bg-color-ff'>
                    <div class='top flex flex-direction flex-center'>
                        <p class=" font-size-36 font-color-12">{{info.Title}}</p>
                        <p class=" margin-top-10 font-size-20 font-color-ab" style="fontWeight:330;">发布时间：{{info.StartTime}}</p>
                    </div>
                    <div class='rich-t font-color-00 font-size-14' v-html="info.Details"></div>
                </div>

                <!-- 更多文章推荐 -->
                <div class='r bg-color-ff'>
                    <div class='top flex align-center bg-color-23'>
                        <img src="../../assets/news/icon-news-menu.png">
                        <p class="font-color-ff font-size-24 margin-left-15">更多文章</p>
                    </div>
                    <div class='content'>
                        <div class="item flex cursor-pointer" v-for="item in rec_list" :key="item.Id" @click="toOther(item.Id)">
                             <div class="img" :style="{backgroundImage:'url('+item.ImageUrl+')'}"></div>
                             <div class='text flex flex-direction justify-between flex-sub'>
                                 <p class="t font-size-18 font-color-484">{{item.Title}}</p>
                                 <p class="des font-size-15 font-color-81">{{item.Intro}}</p>
                             </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- 底部背景图 -->
            <!-- <div class='bg-bottom'></div> -->
        </div>
    </div>
</template>

<script>
    import common from "@/utils/common.js";
    export default {
        data() {
            return {
                Id:0,
                info:{},
                rec_list: [],
            }
        },
        created () {
            this.Id = this.$route.params.Id;
            this.request()
            this.requestMoreActicle()
        },
        methods: {
            request(){
                var that = this
                this.getRequest('api/v1/Article/Details',{Id:this.Id}).then(res=>{
                    if (res.IsSuccess) {
                        res.Data.StartTime = common.formatDateYMD(res.Data.StartTime).allDate
                        that.info = res.Data

                    }
                })
            },
            requestMoreActicle(){
                var that = this
                this.getRequest('api/v1/Article/GetMoreArticles',{Id:this.Id}).then(res=>{
                    if (res.IsSuccess) {
                        that.rec_list = res.Data
                    }
                })
            },
            toOther(Id){
                this.Id = Id
                this.request()
                this.requestMoreActicle()
            }
        },
    }
</script>

<style scoped>
    .bg-top {
  background: url("../../assets/video/icon-video-bg.jpg");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: -1;
}

.content {
  padding-bottom: 0.5rem;
}
    /* .bg-bottom{
        margin-top: -3.5rem;
        background: url('../../assets/video/icon-video-bottombg.png');
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: bottom;
        width: 100%;
        height: 5.97rem;
    } */
    .wrap {
        margin-top: 0.4rem;
        z-index: 2;
    }
    .wrap .l {
        min-height: 0;
        border-radius: 0.16rem;
        box-shadow: 0 0 0.22rem 0.05rem rgba(155, 199, 219, 0.35);
        padding: 0 0.25rem 0.5rem;
    }

    .wrap .l .top {
        height: 1.83rem;
        border-bottom: 0.01rem dashed #ddd;
    }
 
    .wrap .r {
        width: 3.3rem;
        height: 100%;
        border-radius: 0.16rem;
        margin-left: 0.24rem;
        overflow: hidden;
        box-shadow: 0 0 0.22rem 0.05rem rgba(155, 199, 219, 0.35);
    }

    .wrap .r .top {
        height: 0.66rem;
        padding-left: 0.32rem;
    }

    .wrap .r .content {
        padding: 0 0.2rem;
    }

    .wrap .r .content .item:last-child {
        border-bottom: none;
    }

    .wrap .r .content .item {
        padding: 0.29rem 0;
        height: 1.51rem;
        border-bottom: 0.01rem solid #ddd;
    }

    .wrap .r .content .item .img {
        width: 0.95rem;
        height: 0.95rem;
        margin-right: 0.18rem;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center;
    }

    .wrap .r .content .item p {
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
    }

    .rich-t {
        padding-top: 0.3rem;
    }
    

</style>


// WEBPACK FOOTER //
// src/view/news/detail.vue